export default "__VITE_PUBLIC_ASSET__aa07f686__"